module.exports = __webpack_public_path__ + "static/media/security.25084104.jpg";